module.exports = "//static.hsappstatic.net/ComposeUI/static-1.9550/img/compositor_onboarding_modal@2x.gif"